import { Alert, Button, Container, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from "@mui/material"
import { useContext, useEffect, useRef, useState } from "react"
import { UserContext } from "../contexts/user"
import { getProfileInfo, getProfileUserInfo, saveCreateForm } from "../axios/axiosFunctions"
import { useNavigate } from "react-router-dom"

const defaultProfileForm = {
    firstName:"",
    lastName:"",
    email:"",
    company:"",
    industry:"",
    howLongCompany:"",
    functionCompany:[false,false,false,false,false,false,false,false,false,false],
    managementPosition:"",
    titleCompany:"",
    directors:"",
    yearRange:"",
    gender:"",   
}

const CreateProfileForm = () => {

    const navigate = useNavigate();
    const {currentUser} = useContext(UserContext);
    const [profileForm, setProfileForm] = useState(defaultProfileForm);
    const [error, setError] = useState("");
    const [showError, setShowError] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("error");
    const [invalidFields, setInvalidFields] = useState([]);
    const {firstName,lastName,email,company,howLongCompany,functionCompany,managementPosition,titleCompany,directors,yearRange,gender} = profileForm;

    const howLongRef = useRef(null);
    const functionRef = useRef(null);
    const managementRef = useRef(null);
    const titleRef = useRef(null);
    const directorsRef = useRef(null);

    useEffect(() => {
        const callProfileInfo = async()=>{
            const res = await getProfileInfo(currentUser._id);
            if(res){
                const {user} = res;
                setProfileForm({
                    firstName: user.firstName,
                    lastName: user.lastName,
                    email: user.email,
                    company: user.info.company,
                    industry: user.info.industry,
                    howLongCompany:user.info.howLongCompany,
                    functionCompany: user.info.functionCompany,
                    managementPosition: user.info.managementPosition,
                    titleCompany: user.info.titleCompany,
                    directors: user.info.directors,
                    yearRange: user.info.yearRange,
                    gender: user.info.gender
                })
            }
        }
        callProfileInfo();
    }, []);
    

    const handleProfileForm = (e)=>{
        const {name,value} = e.target;
        setProfileForm({...profileForm,[name]:value});
    }

    const handleFunctionRadio = ({target})=> {
        const {value} = target;
        const newfunctionCompany = functionCompany.map(()=>false);
        newfunctionCompany[parseInt(value)] = true;
        setProfileForm({...profileForm,functionCompany:newfunctionCompany});
    }

    const fieldRefs = {
        howLongCompany: howLongRef,
        functionCompany: functionRef,
        managementPosition: managementRef,
        titleCompany: titleRef,
        directors: directorsRef,
    };

    const validateForm = ()=>{
        const invalid = [];
        if(howLongCompany === "") invalid.push("howLongCompany");
        if(!functionCompany.some((v)=>v)) invalid.push("functionCompany");
        if(managementPosition === "") invalid.push("managementPosition");
        if(titleCompany === "") invalid.push("titleCompany");
        if(directors === "") invalid.push("directors");
        return invalid;
    }

    const handleSubmit = async(e)=>{
        e.preventDefault();
        //CHECK FOR THE RADIO AND CHECKBOX TO BE FILL SINCE THEY ARE REQUIRED
        const invalid = validateForm();
        if(invalid.length > 0){
            setInvalidFields(invalid);
            setError("Please fill the required information.");
            setShowError(true);
            const firstRef = fieldRefs[invalid[0]];
            if(firstRef && firstRef.current){
                firstRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            setTimeout(() => {
              setShowError(false);
              setInvalidFields([]);
            }, 4000);
            return;
        }
        
        const res = await saveCreateForm(currentUser._id,profileForm);
        
        if(!res.status){
            setError(res.msg);
            setShowError(true);
            setTimeout(() => {
              setShowError(false);
            }, 4000);
            return;
        }

        setError(res.msg);
        setShowError(true);
        setAlertSeverity("success");
        setTimeout(() => {
            navigate('/')
            setShowError(false);
        }, 4000);
        const updatedUser = {
            ...currentUser,
            firstTime:false
        };
        localStorage.setItem('userK2G',JSON.stringify(updatedUser));
    }

    return (
    <Container sx={{marginTop:"50px"}}>
        <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
                <Grid size={6}>
                    <Typography variant="h6" color="secondary">First Name *</Typography>
                    <TextField required value={firstName} fullWidth onChange={handleProfileForm} name='firstName'/>
                </Grid>
                <Grid size={6}>
                    <Typography variant="h6" color="secondary">Last Name *</Typography>
                    <TextField required value={lastName} fullWidth onChange={handleProfileForm} name='lastName'/>
                </Grid>
                <Grid size={12}>
                    <Typography variant="h6" color="secondary">Email *</Typography>
                    <TextField required defaultValue={email} fullWidth onChange={handleProfileForm} name='email'/>
                </Grid>
                <Grid size={12}>
                    <Typography variant="h6" color="secondary">Company Name *</Typography>
                    <TextField required value={company} fullWidth onChange={handleProfileForm} name='company'/>
                </Grid>
                <Grid size={12} ref={howLongRef}>
                    <Typography variant="h6" sx={{ color: invalidFields.includes("howLongCompany") ? "error.main" : "text.primary", transition: "color 0.3s ease" }}>How long have you been at your current company? *</Typography>
                    <RadioGroup row fullWidth value={howLongCompany} onChange={handleProfileForm} sx={{justifyContent:"space-between",padding:"0px 10px"}}>
                        <FormControlLabel value="less6" name="howLongCompany" control={<Radio/>} label="Less than 6 months"/>
                        <FormControlLabel value="6to1" name="howLongCompany" control={<Radio/>} label="6 months to 1 year"/>
                        <FormControlLabel value="1to3" name="howLongCompany" control={<Radio/>} label="Between 1 and 3 years"/>
                        <FormControlLabel value="more3" name="howLongCompany" control={<Radio/>} label="More than 3 years"/>
                    </RadioGroup>
                </Grid>
                <Grid size={12} ref={functionRef}>
                    <Typography variant="h6" sx={{ color: invalidFields.includes("functionCompany") ? "error.main" : "text.primary", transition: "color 0.3s ease" }}>In which Function do you work? *</Typography>
                    <RadioGroup row value={String(functionCompany.indexOf(true))} onChange={handleFunctionRadio}>
                        <FormControlLabel sx={{margin:{xs:"0px"}}} control={<Radio/>} value="0" label="C-Suite"/>
                        <FormControlLabel sx={{margin:{xs:"0px"}}} control={<Radio/>} value="1" label="IT"/>
                        <FormControlLabel sx={{margin:{xs:"0px"}}} control={<Radio/>} value="2" label="F&A"/>
                        <FormControlLabel sx={{margin:{xs:"0px"}}} control={<Radio/>} value="3" label="Operations"/>
                        <FormControlLabel sx={{margin:{xs:"0px"}}} control={<Radio/>} value="4" label="HR"/>
                        <FormControlLabel sx={{margin:{xs:"0px"}}} control={<Radio/>} value="5" label="Legal"/>
                        <FormControlLabel sx={{margin:{xs:"0px"}}} control={<Radio/>} value="6" label="Customer Services"/>
                        <FormControlLabel sx={{margin:{xs:"0px"}}} control={<Radio/>} value="7" label="Sales & Marketing"/>
                        <FormControlLabel sx={{margin:{xs:"0px"}}} control={<Radio/>} value="8" label="Manufacturing"/>
                        <FormControlLabel sx={{margin:{xs:"0px"}}} control={<Radio/>} value="9" label="R&D"/>
                        <FormControlLabel sx={{margin:{xs:"0px"}}} control={<Radio/>} value="10" label="Other"/>
                    </RadioGroup>
                </Grid>
                <Grid size={12} ref={managementRef}>
                    <Typography variant="h6" sx={{ color: invalidFields.includes("managementPosition") ? "error.main" : "text.primary", transition: "color 0.3s ease" }}>What type of management position do you hold? *</Typography>
                    <RadioGroup required row fullWidth value={managementPosition} onChange={handleProfileForm} sx={{justifyContent:"space-between",padding:"0px 10px"}}>
                        <FormControlLabel value="DMO" name="managementPosition" control={<Radio/>} label="Direct Manager of Others"/>
                        <FormControlLabel value="MM" name="managementPosition" control={<Radio/>} label="Manager of Managers"/>
                        <FormControlLabel value="MMDR" name="managementPosition" control={<Radio/>} label="Matrix Manager without Direct Reports"/>
                        <FormControlLabel value="NMY" name="managementPosition" control={<Radio/>} label="Not a Manager Yet"/>
                        <FormControlLabel value="other" name="managementPosition" control={<Radio/>} label="Other"/>
                    </RadioGroup>
                </Grid>
                <Grid size={12} ref={titleRef}>
                    <Typography variant="h6" sx={{ color: invalidFields.includes("titleCompany") ? "error.main" : "text.primary", transition: "color 0.3s ease" }}>What is your title? *</Typography>
                    <RadioGroup row fullWidth value={titleCompany} onChange={handleProfileForm} sx={{justifyContent:"space-between",padding:"0px 10px"}}>
                        <FormControlLabel value="supervisor" name="titleCompany" control={<Radio/>} label="Supervisor"/>
                        <FormControlLabel value="manager" name="titleCompany" control={<Radio/>} label="Manager/Sr. Manager"/>
                        <FormControlLabel value="director" name="titleCompany" control={<Radio/>} label="Director (All Levels)"/>
                        <FormControlLabel value="vp" name="titleCompany" control={<Radio/>} label="VP (All Levels)"/>
                        <FormControlLabel value="csuite" name="titleCompany" control={<Radio/>} label="C-Suite"/>
                        <FormControlLabel value="other" name="titleCompany" control={<Radio/>} label="Other"/>
                    </RadioGroup>
                </Grid>
                <Grid size={12} ref={directorsRef}>
                    <Typography variant="h6" sx={{ color: invalidFields.includes("directors") ? "error.main" : "text.primary", transition: "color 0.3s ease" }}>How many direct reports do you have: *</Typography>
                    <RadioGroup row fullWidth value={directors} onChange={handleProfileForm} sx={{justifyContent:"space-between",padding:"0px 10px"}}>
                        <FormControlLabel value="0" name="directors" control={<Radio/>} label="0"/>
                        <FormControlLabel value="1to5" name="directors" control={<Radio/>} label="1 to 5"/>
                        <FormControlLabel value="6to9" name="directors" control={<Radio/>} label="6 to 9"/>
                        <FormControlLabel value="more10" name="directors" control={<Radio/>} label="10+"/>
                    </RadioGroup>
                </Grid>
                <Grid size={12}>
                    <Typography variant="h6" color="secondary">Optional demographic questions used for research purposes only:</Typography>
                </Grid>
                <Grid size={12}>
                    <Typography variant="h6">Please indicate your birth year range</Typography>
                    <RadioGroup row fullWidth value={yearRange} onChange={handleProfileForm} sx={{justifyContent:"space-between",padding:"0px 10px"}}>
                        <FormControlLabel value="later1996" name="yearRange" control={<Radio/>} label="1996 or later"/>
                        <FormControlLabel value="1977to1995" name="yearRange" control={<Radio/>} label="1977-1995"/>
                        <FormControlLabel value="1965to1976" name="yearRange" control={<Radio/>} label="1965-1976"/>
                        <FormControlLabel value="1946to1964" name="yearRange" control={<Radio/>} label="1946-1964"/>
                        <FormControlLabel value="before1945" name="yearRange" control={<Radio/>} label="1945 or before"/>
                    </RadioGroup>
                </Grid>
                <Grid size={12}>
                    <Typography variant="h6">Please indicate your gender</Typography>
                    <RadioGroup row fullWidth value={gender} onChange={handleProfileForm} sx={{justifyContent:"space-between",padding:"0px 10px"}}>
                        <FormControlLabel value="female" name="gender" control={<Radio/>} label="Female"/>
                        <FormControlLabel value="male" name="gender" control={<Radio/>} label="Male"/>
                        <FormControlLabel value="trans" name="gender" control={<Radio/>} label="Transgender"/>
                        <FormControlLabel value="nonBinary" name="gender" control={<Radio/>} label="Non-binary"/>
                        <FormControlLabel value="notListed" name="gender" control={<Radio/>} label="Not Listed"/>
                        <FormControlLabel value="notAnswer" name="gender" control={<Radio/>} label="Prefer not to answer"/>
                    </RadioGroup>
                </Grid>
                {
                    showError &&
                    <Grid size={12}>
                        <Alert sx={{marginTop:"20px"}} severity={alertSeverity}>
                            {error}
                        </Alert>
                    </Grid>
                }
                <Grid size={12}>
                    <Typography variant="body2" sx={{ color: "text.secondary", mt: 1 }}>* Required field</Typography>
                </Grid>
                <Grid size={12} sx={{display:"flex",justifyContent:"center"}}>
                    <Button type='submit' sx={{marginTop:{xs:"20px",sm:"50px"}, marginBottom:"10px"}} size="large" variant="contained" color="secondary">SAVE AND CONTINUE</Button>
                </Grid>
            </Grid>
        </form>
    </Container>
    )
}

export default CreateProfileForm